import { AnalyticsPermissionEnum } from '../../../../core/enums/analytics-permission.enum'
import { BookInterface } from '../../../../core/interface/book.interface'
import { WorkMirrorBookInterface } from '../../../../core/interface/report/work-mirror-book.interface'
import DynamicBooksInput from './DynamicBooksInput'
import PreviewBooksInput from './PreviewBooksInput'

type Props = {
  booksInputsMenuOpen: boolean
  isLoadingNewConstellationGetBookReco: boolean
  isLoadingAdd: boolean
  isLoadingRemove: boolean
  booksInput: BookInterface[]
  handleAddBookToAnalytic: (eanId: number) => void
  handleRemoveBookInput: (eanId: number) => void
  bookDetailsSelected: WorkMirrorBookInterface | null
  handleBookSelected: (book: WorkMirrorBookInterface | null) => void
  permission?: AnalyticsPermissionEnum
}

const BooksInput = ({
  booksInputsMenuOpen,
  isLoadingNewConstellationGetBookReco,
  isLoadingAdd,
  isLoadingRemove,
  booksInput,
  handleAddBookToAnalytic,
  handleRemoveBookInput,
  bookDetailsSelected,
  handleBookSelected,
  permission,
}: Props) => {
  if (booksInputsMenuOpen) {
    return (
      <DynamicBooksInput
        booksInput={booksInput}
        bookDetailsSelected={bookDetailsSelected}
        handleAddBookToAnalytic={handleAddBookToAnalytic}
        handleBookSelected={handleBookSelected}
        handleRemoveBookInput={handleRemoveBookInput}
        isLoadingAdd={isLoadingAdd}
        isLoadingRemove={isLoadingRemove}
        permission={permission}
        isLoadingNewConstellationGetBookReco={
          isLoadingNewConstellationGetBookReco
        }
      />
    )
  }

  return (
    <PreviewBooksInput
      booksInput={booksInput}
      permission={permission}
      isLoadingRemove={isLoadingRemove}
      isLoadingNewConstellationGetBookReco={
        isLoadingNewConstellationGetBookReco
      }
    />
  )
}

export default BooksInput
